import React, {
    createContext,
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react';
import {toast} from 'react-toastify';
import {gitCommitSha} from '^utilities/dataSet';

export const AppContext = createContext(null);

export const AppContextProvider = ({children}) => {
    const [leftNavOpen, setLeftNavOpen] = useState(false);
    const [asideChildren, setAsideChildren] = useState(null);
    const [showScrollButtons, setShowScrollButtons] = useState(false);
    const newVersionToastId = useRef(null);

    useEffect(() => {
        const appRefreshWorker = new Worker(new URL(
            './appRefresh.worker.js',
            import.meta.url,
        ));

        appRefreshWorker.addEventListener('message', () => {
            if (newVersionToastId.current) return;

            newVersionToastId.current = toast.warning(
                <>
                    {'A new version of LabTracker is available. '}
                    <div
                        className={'d-inline text-decoration-underline'}
                        role={'button'}
                        onClick={() => window.location.reload()}
                    >
                        {'Refresh'}
                    </div>
                </>,
                {
                    autoClose: false,
                    closeButton: false,
                    draggable: false,
                },
            );
        });

        appRefreshWorker.postMessage({
            gitCommitSha,
            origin: window.location.origin,
        });

        return () => {
            toast.dismiss(newVersionToastId.current);
            appRefreshWorker.terminate();
        };
    }, []);

    const setLeftNavOpenCallback = useCallback((val) => {
        setLeftNavOpen(val);

        if (val) {
            // Close the aside when opening the nav
            setAsideChildren(null);
        }
    }, []);

    const setAsideChildrenCallback = useCallback((val) => {
        setAsideChildren(val);

        if (val) {
            // Close the left nave when opening the aside
            setLeftNavOpen(false);
        }
    }, []);

    return <AppContext.Provider value={{
        leftNavOpen,
        setLeftNavOpen: setLeftNavOpenCallback,
        asideChildren,
        setAsideChildren: setAsideChildrenCallback,
        showScrollButtons,
        setShowScrollButtons,
    }}>
        {children}
    </AppContext.Provider>;
};
